import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./cookiebanner.css";

const CookieBanner = ({ onClose }) => {
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("cookieConsent");
    if (saved) {
      const parsed = JSON.parse(saved);
      if (document.getElementById("analytics"))
        document.getElementById("analytics").checked = parsed.analytics;
      if (document.getElementById("marketing"))
        document.getElementById("marketing").checked = parsed.marketing;
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({ necessary: true, analytics: true, marketing: true })
    );
    onClose();
  };

  const declineAll = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({ necessary: true, analytics: false, marketing: false })
    );
    onClose();
  };

  const saveSettings = () => {
    const analytics = document.getElementById("analytics").checked;
    const marketing = document.getElementById("marketing").checked;

    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({ necessary: true, analytics, marketing })
    );

    onClose();
  };

  return (
    <div className="cookie-banner-wrapper">
      <div className="cookie-banner-card">
        <h3 className="cookie-title">🍪 We use cookies</h3>

        <p className="cookie-text">
          We use cookies to improve our website and provide you with an optimal user experience.
        </p>

        <p className="cookie-privacy-link">
          <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
            View privacy policy
          </Link>
        </p>

        {!showSettings && (
          <>
            <div className="cookie-buttons">
              <button className="btn-primary" onClick={acceptAll}>
                Accept all
              </button>
              <button className="btn-secondary" onClick={declineAll}>
                Reject
              </button>
              <button
                className="btn-tertiary"
                onClick={() => setShowSettings(true)}
              >
                Settings
              </button>
            </div>
          </>
        )}

        {showSettings && (
          <div className="cookie-settings">
            <label className="cookie-option">
              <input type="checkbox" checked disabled /> Necessary cookies
            </label>

            <label className="cookie-option">
              <input id="analytics" type="checkbox" /> Statistics cookies
            </label>

            <label className="cookie-option">
              <input id="marketing" type="checkbox" /> Marketing cookies
            </label>

            <div className="cookie-buttons">
              <button className="btn-primary" onClick={saveSettings}>
                Save settings
              </button>
              <button
                className="btn-tertiary"
                onClick={() => setShowSettings(false)}
              >
                Back
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CookieBanner;
